import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { NotificationService } from '../../../../services/notification.service';
import { ChatService } from '../../../../services/chat.service';
import { Message } from '../../../../models/message.model';
import { MessageThread } from '../../../../models/messageThread.model';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SharedService } from '../../../page/shared.service';
import { Subscription, timer } from 'rxjs';
import { AuthService } from '../../../../services/auth.service';
import { User } from '../../../../models/user.model';


@Component({
  selector: 'app-reply-message',
  templateUrl: './reply-message.component.html',
  styleUrls: ['./reply-message.component.scss']
})
export class ReplyMessageComponent implements OnInit {
  messages: Message[] = [];
  nonAnsweredMessages: Message[] = [];
  nonAnsweredMessagesTmp: Message[] = [];
  answeredMessages: Message[] = [];
  answeredMessagesTmp: Message[] = [];
  displayedMessages: Message[] = [];
  displayedMessagesTmp: Message[] = [];
  selectedMessage: Message | null = null;
  replyContent = '';
  search = '';
  chatNotifications: Notification[] = [];
  subscription !: Subscription;
  user!: User;
  userAuthentificate: boolean = false;

  @ViewChild('messageThreadContainer') messageThreadContainer: ElementRef<HTMLDivElement>;
  constructor(private fb: FormBuilder,
              private notificationService: NotificationService,
              private chatService: ChatService,
              private router: Router,
              public sharedSevice: SharedService,
              private authService: AuthService) { }

  ngOnInit() {
    this.showAllMessages();
    this.getUserConnected();
  }

  showAllMessages() {
    this.chatService.loadChatMessages().subscribe(rs => {
      this.messages = rs;
     // console.log("Liste de tous les messages...")
     // console.log(rs)
      this.nonAnsweredMessages = this.sortMessagesByDate(this.messages.filter(message => !message.replied));
      this.nonAnsweredMessagesTmp = this.messages.filter(message => !message.replied);
      // this.nonAnsweredMessagesTmp = this.messages.filter(message => !message.replied);
      this.answeredMessages = this.sortMessagesByDate(this.messages.filter(message => message.replied));
      // this.answeredMessages = this.messages.filter(message => message.replied);
      this.answeredMessagesTmp = this.messages.filter(message => message.replied);
      this.displayedMessagesTmp = this.messages;
      this.filterMessages('all');
    });
  }

  getUserConnected = () => {
    this.authService.authenticated() ?  this.userAuthentificate = true : this.userAuthentificate = false;

    this.authService.getUSerBySessionId().subscribe((response: any) => {
      this.user = response;
      // console.log("-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-_-")
      // console.log(this.user);
    }, (error: any) => {
      // console.log(error);
    });
  }

  searchFilter($event: KeyboardEvent) {
    this.search = this.search.toString().toLowerCase();
    this.displayedMessages = this.sortMessagesByDate(
      this.displayedMessagesTmp.filter(value =>
        value.userLastname?.toUpperCase().includes(this.search) || value.userLastname?.toLowerCase().includes(this.search)
        || value?.userFirstname?.toUpperCase().includes(this.search) || value?.userFirstname?.toLowerCase().includes(this.search)
        || value?.username?.toUpperCase().includes(this.search) || value?.username?.toLowerCase().includes(this.search)));

    this.nonAnsweredMessages = this.sortMessagesByDate(
      this.nonAnsweredMessagesTmp.filter(value =>
        value.userLastname?.toUpperCase().includes(this.search) || value.userLastname?.toLowerCase().includes(this.search)
        || value?.userFirstname?.toUpperCase().includes(this.search) || value?.userFirstname?.toLowerCase().includes(this.search)
        || value?.username?.toUpperCase().includes(this.search) || value?.username?.toLowerCase().includes(this.search)));

    this.answeredMessages = this.sortMessagesByDate(
      this.answeredMessagesTmp.filter(value =>
        value.userLastname?.toUpperCase().includes(this.search) || value.userLastname?.toLowerCase().includes(this.search)
        || value?.userFirstname?.toUpperCase().includes(this.search) || value?.userFirstname?.toLowerCase().includes(this.search)
        || value?.username?.toUpperCase().includes(this.search) || value?.username?.toLowerCase().includes(this.search)));

  }

  filterMessages(type: string) {
    switch (type) {
      case 'unanswered':
        // this.displayedMessages = this.nonAnsweredMessages;
        this.displayedMessages = this.sortMessagesByDate(this.nonAnsweredMessages);
        break;
      case 'answered':
        this.displayedMessages = this.sortMessagesByDate(this.answeredMessages);
        // this.displayedMessages = this.answeredMessages;
        break;
      default:
        this.displayedMessages = this.sortMessagesByDate(this.messages);
        // this.displayedMessages = this.messages;
        break;
    }
  }

  sortMessagesByDate(messages: Message[]): Message[] {
    return messages.sort((a, b) => {
      const dateA = new Date(a.createdAt);
      const dateB = new Date(b.createdAt);
      return dateB.getTime() - dateA.getTime();
    });
  }

  selectMessage(message: Message) {
    this.selectedMessage = message;
    //console.log("Messages sectionné.............")
    //console.log(this.selectedMessage)
    setTimeout(() => {
      this.scrollToBottom();
    }, 0);
  }

  isClientMessage(thread: MessageThread): boolean {
    return thread.type === 'customer' && thread.receiver === null;
  }

  get f() { return this.chatForm.controls; }
  chatForm = this.fb.group({
    type: new FormControl('', []),
    message: new FormControl('', []),
    sender: new FormControl('', []),
    receiver: new FormControl('', []),
  });


  replyToMessage() {
    if(this.replyContent){
      if (this.selectedMessage) {
        const newReply: MessageThread = {
          receiver: this.selectedMessage.username,
          type: 'admin',
          message: this.replyContent,
          replied: true,
        };
        this.chatService.replyChatNotifications(newReply).subscribe(rs=>{
          // console.log(rs);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Votre message a été envoyé avec succès"',
            showConfirmButton: false,
            timer: 1500
          });
          this.selectedMessage.chats.push(newReply);
          this.showAllMessages();
          this.loadChatNotification();
          this.replyContent = '';
          this.chatForm.reset();
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
        })
      }
    }else{
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: 'Le message ne doit pas être vide.',
        showConfirmButton: false,
        timer: 2500
      });
    }
  }

  loadChatNotification() {
    this.notificationService.getChatNotification().subscribe(rs => {
      this.chatNotifications = rs;
      this.sharedSevice.valeurPartagee = this.chatNotifications.length;
    });
  }


  // Fonction de suppression de message
  deleteMessage(id) {
    this.chatService.deleteChat(id).subscribe(rs=>{
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Message supprimé avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.selectedMessage.chats = this.selectedMessage.chats.filter(chat => chat.id !== id);
    }, error => {
      Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: error.error.errorMessage,
        showConfirmButton: false,
        timer: 2500
      });
    })
  }

  markNotificationAsRead(id: any) {
    this.notificationService.markNotificationAsRead(id).subscribe(rs => {
      this.showAllMessages();
    });
  }

  findLastCustomerId(): number {
    for (let i = this.selectedMessage.chats.length - 1; i >= 0; i--) {
      const chat = this.selectedMessage.chats[i];
      if (chat.type === 'customer' && chat.receiver === null) {
        return chat.id;
      }
    }
    return -1; // Retourne -1 si aucun chat avec les critères n'est trouvé
  }

  // Fonction pour faire défiler jusqu'au bas de la liste des messages
  scrollToBottom() {
    const container = this.messageThreadContainer.nativeElement;
    container.scrollTop = container.scrollHeight;
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }
}
